let timeStr = '0';
export const hours = () => {
    const hr = [];
    for (let h = 0; h < 24; h += 1) {
        if (h < 10) {
            timeStr += h;
            hr.push(timeStr);
            timeStr = '0';
        } else {
            hr.push(h.toString());
        }
    }
    return hr;
};
export const minutes = () => {
    const mm = [];
    for (let h = 0; h < 60; h += 1) {
        if (h < 10) {
            timeStr += h;
            mm.push(timeStr);
            timeStr = '0';
        } else {
            mm.push(h.toString());
        }
    }
    return mm;
};
